'use strict';

export class DataListHelper {
  static MAXIMUN_QUERYABLE_ROW_COUNT = 10000;

  static getTotalSelectedRows(rawdata: any, checkSelectedRow: any, inverseSelectionWhenEmpty: boolean) {
    rawdata = rawdata || [];
    let data = rawdata.dataList || rawdata;
    let pagination = rawdata.pagination || {total: rawdata.length};

    if (!data) return 0;
    if (data.filter(checkSelectedRow).length === 0 && inverseSelectionWhenEmpty) return Math.min(this.MAXIMUN_QUERYABLE_ROW_COUNT, pagination.total);
    else return Math.min(this.MAXIMUN_QUERYABLE_ROW_COUNT, data.filter(checkSelectedRow).length);
  }

  static getDisabledState(rawdata: any, checkSelectedRow: any, inverseSelectionWhenEmpty: boolean) {
    if (!rawdata) return 'disabled';
    if (this.getTotalSelectedRows(rawdata, checkSelectedRow, inverseSelectionWhenEmpty) == 0) return 'disabled';
    else return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/helpers/data-list.helper.ts